export enum Domain {
  PAY_PORTAL = 'PAY_PORTAL',
  DASHBOARD = 'DASHBOARD',
}

export enum ProductConfigName {
  // Dashboard & Mobile
  API_DISBURSE = 'API_DISBURSE',
  MANUAL_TOPUP = 'MANUAL_TOPUP',
  AUTO_REPORT = 'AUTO_REPORT',
  BULK_DISBURSE = 'BULK_DISBURSE',
  VA_TOPUP = 'VA_TOPUP',
  MANUAL_WITHDRAWAL = 'MANUAL_WITHDRAWAL',
  INTERNATIONAL_TRANSFER = 'INTERNATIONAL_TRANSFER',
  NOTIFICATION = 'NOTIFICATION',
  REFUND_REPORT = 'REFUND_REPORT',

  // Payportal
  MANUAL_TRANSACTION = 'MANUAL_TRANSACTION',
  PRODUCT_CONFIG = 'PRODUCT_CONFIG',
  FREEZE_BALANCE = 'FREEZE_BALANCE',
  DRAIN_TRANSACTION = 'DRAIN_TRANSACTION',
  B2X_KYB_LOCKS = 'B2X_KYB_LOCKS',
  INSIGHT_INFO = 'INSIGHT_INFO',
  B2X_UPDATE_TX_STATUS = 'B2X_UPDATE_TX_STATUS',
  USER_GROUP_MANAGEMENT = 'USER_GROUP_MANAGEMENT',
}

export enum Key {
  // API_DISBURSE
  SHOW_VENDOR_MAINTENANCE = 'SHOW_VENDOR_MAINTENANCE',
  WHITELIST_EXPORT = 'WHITELIST_EXPORT',
  WHITELIST_RECEIPT = 'WHITELIST_RECEIPT',

  // MANUAL_TOPUP
  UNDER_MAINTENANCE = 'UNDER_MAINTENANCE',

  // AUTO_REPORT
  DISBURSEMENT = 'DISBURSEMENT',
  PAYMENT_ACCEPTANCE = 'PAYMENT_ACCEPTANCE',

  // REFUND_REPORT
  ACTIVE_PRODUCTS = 'ACTIVE_PRODUCTS',

  // BULK_DISBURSE
  WHITELIST_KEY_NAME = 'WHITELIST_KEY_NAME',
  KEY_NAME_SANITIZED = 'KEY_NAME_SANITIZED',
  WHITELIST_CREATE_SERIAL = 'WHITELIST_CREATE_SERIAL',
  WHITELIST_SIMPLIFIED_BOOLEAN = 'WHITELIST_SIMPLIFIED_BOOLEAN',
  WHITELIST_PRIORITY_QUEUE = 'WHITELIST_PRIORITY_QUEUE',
  IS_READJUST_ACTIVE = 'IS_READJUST_ACTIVE',
  DOWNLOAD_TIMEOUT = 'DOWNLOAD_TIMEOUT',
  BANK_JSON_FLAG = 'BANK_JSON_FLAG',
  WHITELIST_PRICING = 'WHITELIST_PRICING',
  IS_PRICING_RELEASE = 'IS_PRICING_RELEASE',
  WHITELIST_SUB_ENTITY = 'WHITELIST_SUB_ENTITY',
  SHOW_SUB_ENTITY = 'SHOW_SUB_ENTITY',
  IS_APPROVAL_RELEASE = 'IS_APPROVAL_RELEASE',

  // INTERNATIONAL_TRANSFER
  IS_SOF_ACTIVE = 'IS_SOF_ACTIVE',

  // MANUAL_TRANSACTION
  DEFAULT_MONTHLY_LIMIT = 'DEFAULT_MONTHLY_LIMIT',

  // PRODUCT_CONFIG
  DISBURSEMENT_CONFIG_APPROVAL = 'DISBURSEMENT_CONFIG_APPROVAL',
  DISBURSEMENT_PRICING_CONFIG_APPROVAL = 'DISBURSEMENT_PRICING_CONFIG_APPROVAL',
  WHITELIST_PRICING_TESTING = 'WHITELIST_PRICING_TESTING',
  FULL_RELEASE_PRICING = 'FULL_RELEASE_PRICING',
  WITHDRAWAL_APPROVAL = 'WITHDRAWAL_APPROVAL',
  DISBURSEMENT_CONFIG_SHOWN_SECTIONS = 'DISBURSEMENT_CONFIG_SHOWN_SECTIONS',
  GENERAL_HIDDEN_FIELDS = 'GENERAL_HIDDEN_FIELDS',

  // FREEZE_BALANCE
  WHITELIST_FREEZE_PERMISSION = 'WHITELIST_FREEZE_PERMISSION',

  // DRAIN_TRANSACTION
  IGNORE_USER = 'IGNORE_USER',
  IS_LOCKED_FLAG = 'IS_LOCKED_FLAG',
  TIME_LOCKED_BALANCE = 'TIME_LOCKED_BALANCE',
  TIME_EXECUTED_BALANCE = 'TIME_EXECUTED_BALANCE',
  USER_DRAIN = 'USER_DRAIN',
  LOCKED_USER = 'LOCKED_USER',
  USER_CATEGORY = 'USER_CATEGORY',
  IS_FORCE_MODE = 'IS_FORCE_MODE',
  METABASE_HISTORY = 'METABASE_HISTORY',
  DELAY_LOCKED_BALANCE = 'DELAY_LOCKED_BALANCE',

  // B2X_UPDATE_TX_STATUS
  SHOWN_TABS = 'SHOWN_TABS',

  // CLAIM_FUND_API
  IS_CLAIM_FUND_API_ACTIVE = 'IS_CLAIM_FUND_API_ACTIVE',

  // USER_GROUP_MANAGEMENT
  TENANT_OPTIONS = 'TENANT_OPTIONS',
}

export type FrontendConfig = {
  productName: ProductConfigName;
  domain: string;
  key: Key;
  value: string;
};

export type QueueItem = {
  data: FrontendConfig[];
  key: string;
};
